import { ClientEntity } from 'api/types/entity';
import { yesOrNotOption } from 'helpers';
import { TFunc } from 'libs/i18n';
import { parseBaseGeneralValue } from 'modules/client/common/helpers';

import { GeneralFormType } from '../../forms/generalForm';

export const parseGeneralValue = (client: ClientEntity, t: TFunc) => {
  const values: GeneralFormType['general'] = {
    ...parseBaseGeneralValue(client, t),
    clientType: client.clientType
      ? {
          label: t(
            `client.client.generalSection.clientType.types.${client.clientType}`
          ),
          value: client.clientType,
        }
      : null,

    classification: client.classification
      ? {
          label: t(
            `client.client.generalSection.classification.types.${client.classification}`
          ),
          value: client.classification,
        }
      : null,

    economicSector: client.economicSector
      ? {
          label: t(
            `client.client.generalSection.economicSector.types.${client.economicSector}`
          ),
          value: client.economicSector,
        }
      : null,

    category: client.category
      ? {
          label: t(
            `client.client.generalSection.category.@types.${client.category}`
          ),
          value: client.category,
        }
      : null,

    isInsider: yesOrNotOption(t, client.isInsider) ?? null,
  };

  return values;
};
